import ContainerCard from '../../../../common/components/ContainerCard';
import { env } from '../../../../env';
import { IEntry } from '../../../../models/Account/IEntry';
import styles2 from '../../AccountPage.module.css';
import styles from './CertificationSection.module.css';
import PromoContent from './components/PromoContent';

const recertUrl = env.REACT_APP_RECERT_URL;
const qualifyUrl = env.REACT_APP_QUALIFY_URL;
const prdUrl = env.REACT_APP_PDC_URL;

type CertificationProps = {
  data: IEntry;
};

const Certification = (props: CertificationProps) => {
  return (
    <>
      {props.data?.membershipModel.certifications && (
        <ContainerCard className={styles2.cardDimensions}>
          <div className={styles.title}>CERTIFICATION</div>
          <div className={styles.subtitleBold}>
            You have earned a {props.data.membershipModel?.certifications}
          </div>
          <div className={styles.subtitleRegular}>
            <span>Earned: {props.data.membershipModel.certificationBeginDate}</span>
            <span>&nbsp;|&nbsp;</span>
            <span>Expires: {props.data.membershipModel?.certificationEndDate}</span>
          </div>
          <hr className={styles.divider} />
          <a href={recertUrl} target='_blank' className={styles.linkBlue}>
            Recertification Requirements
          </a>
          <a href={qualifyUrl} target='_blank' className={styles.linkBlue}>
            Qualifying Activities
          </a>
          <a href={prdUrl} target='_blank' className={styles.linkBlue}>
            Log PDCs
          </a>
        </ContainerCard>
      )}
      {!props.data?.membershipModel.certifications && (
        <ContainerCard className={styles2.cardDimensions}>
          <PromoContent />
        </ContainerCard>
      )}
    </>
  );
};

export default Certification;
